import { Box, TextField } from "@mui/material"
import { useState } from "react"
import { isNil, max, min } from "lodash"
import { RslSetttingDto } from "../../RslDataType"

interface BaseSettingsDisplayProps{
    setting?: RslSetttingDto,

    setIndex?: (v: number) => void
    index?: number,
    displayField?: true,
    indexesDisplayField?: Array<number>
    maxValueField?: number
    subValue?: number,
    setSubValue?: (v: number) => void

    //esthetique
    width?: number
    widthSettingName?: number
    widthName?: number
    top?: number,
    left?: number
}

const BaseSettingsDisplay = (props : BaseSettingsDisplayProps ) => {

    let {setting, index, setIndex, displayField, indexesDisplayField, maxValueField, 
        width, widthSettingName, widthName, top, left} = props;

    let [localValue, setLocalValue] = useState(0);

    let value = !isNil(props.subValue) ? props.subValue : localValue;
    let setValue = !isNil(props.setSubValue) ? props.setSubValue : setLocalValue;
    
    if(isNil(index) || isNil(setIndex))
        return null;

    let settingState = "";
    if(index <= -1)
        settingState = "?"
    else
        settingState = setting?.states?.[index]?.name ?? ""

    //if the settings state is null or undefined, we show the user that the settings haven't be found yet

    let isDefault = settingState === setting?.defaultState && !isNil(setting.defaultState);
    let color = "inherit"
    if(settingState !== "?")
        color = "rgb(0, 255, 64)"
    if(isDefault)
        color = "rgba(236, 5, 5, 0.88)";

    const incrementState = () => {
        let tmpIndex = (index ?? 0) + 1;
        if(tmpIndex >= (setting?.states.length ?? 0) )
            tmpIndex = -1

        if(!isNil(setIndex))
            setIndex(tmpIndex);
    }

    const decrementState = () => {
        let tmpIndex = (index ?? 0) -  1;
        if((index ?? 0) < -1)
            tmpIndex = (setting?.states?.length ?? 0) -1 

        if(!isNil(setIndex))
            setIndex(tmpIndex);
    }

     const handleWheelSetting = (e: React.WheelEvent<HTMLDivElement>) => {
    
   
            if (e.deltaY > 0)
                decrementState();
            else
                incrementState();
            
        }

        const handleWheelNumber= (e: React.WheelEvent<HTMLDivElement>) => {
            
            let val = 0;
   
            if (e.deltaY > 0){
                val = max([value - 1, 0]) ?? 0;
            }
            else if(!isNil(maxValueField)){
                val = min([value + 1, maxValueField]) ?? 0; 
            }
            else{
                val = value + 1;
            }
            
            setValue(val)
            if(!isNil(props.setSubValue))
                props.setSubValue(val);
        }

    return <Box marginRight={"5px"} display={"flex"}  width={width} position={"absolute"} top={top} left={left} sx={{opacity: isDefault ? 0.5 : 1}}>
        <Box  onWheel={handleWheelSetting}  onClick={incrementState} onContextMenu={(e) => {e.preventDefault(); decrementState()} }  display={"flex"}  flexDirection={"row"} justifyContent={"space-between"}>
            <Box  display={"flex"} width={widthName} sx={{textDecoration: isDefault ? "line-through" : "inherit"}}>{setting?.name} : </Box>
            <Box marginLeft={"5px"} minWidth={30}  justifyContent={"center"} display={"flex"} color={color} width={widthSettingName}>{settingState}</Box>
        </Box>
        {displayField && !isNil(indexesDisplayField) && settingState !== "?" && indexesDisplayField.some(x => x === index) &&<Box marginLeft={"5px"} marginTop={"-2px"} onWheel={handleWheelNumber}>
                 <TextField size="small" sx={{ width: "30px", style: { textAlign: "center", fontSize: "65px"}}} InputProps={{disableUnderline: true, }} variant="standard"  placeholder={"Specify number"} value={value} onChange={(e) => {
                                                                                                                                                                                                                                        setValue(Number(e.currentTarget.value))
                                                                                                                                                                                                                                        if(!isNil(props.setSubValue))
                                                                                                                                                                                                                                            props.setSubValue(Number(e.currentTarget.value))
                 }}/>
        </Box>}
    </Box>
}

export default BaseSettingsDisplay